import { useModal } from "@/features/modal/ModalStackManager";
import { MoldCavityCreateForm } from "@/features/mold/cavity/form/cavityCreateForm";
import { MoldCavityTable } from "@/features/mold/cavity/table";
import { FormMain } from "@/features/standard/Form/FormMain";
import { Box, Button, Text, Title } from "@mantine/core";
import { useTranslation } from "react-i18next";

const Cavity = Object.assign(FormMain, {
  Text: Text,
  Title: Title,
  Box: Box,
  Button: Button,
});

export interface MoldCodeProps {
  moldCodeProps?: string | undefined;
}

export const CavityForm = ({ moldCodeProps }: MoldCodeProps) => {
  const { openModal } = useModal();
  const { t } = useTranslation();

  return (
    <>
      <Cavity.Title order={3}>{t("moldCavity.cavity")}</Cavity.Title>
      <Cavity.Text pb={12}>{t("moldCavity.description")}</Cavity.Text>
      <Cavity.Box
        sx={(theme) => ({
          backgroundColor:
            theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.colors.gray[0],
          padding: theme.spacing.md,
          borderRadius: theme.radius.sm,
          marginBottom: theme.spacing.md,
        })}
      >
        <Cavity.Button
          onClick={() => {
            openModal(
              <MoldCavityCreateForm moldCodeProps={moldCodeProps} />,
              null,
              `${t("common.additional", { item: `${t("moldCavity.cavity")}` })}`,
              true,
            );
          }}
        >
          {t("common.additional", { item: `${t("moldCavity.cavity")}` })}
        </Cavity.Button>
      </Cavity.Box>
      <MoldCavityTable moldCodeProps={moldCodeProps} />
    </>
  );
};
